// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CabX","col":"styles_col__1WS-m"};